import type { DomEnvironment } from './types';

const noop = () => {
    /* noop */
};

const fallbackRequestAnimationFrame: DomEnvironment['requestAnimationFrame'] = (callback) => {
    return Number(setTimeout(() => callback(Date.now()), 16));
};

const fallbackCancelAnimationFrame: DomEnvironment['cancelAnimationFrame'] = (handle) => {
    clearTimeout(handle);
};

const fallbackSetTimeout: DomEnvironment['setTimeout'] = (callback, timeout) => {
    return Number(setTimeout(callback, timeout));
};

const fallbackClearTimeout: DomEnvironment['clearTimeout'] = (handle) => {
    if (typeof handle === 'undefined') return;
    clearTimeout(handle);
};

const createDomEnvironment = (): DomEnvironment => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return {
            window: null,
            document: null,
            focusElement: noop,
            getElementById: () => null,
            requestAnimationFrame: fallbackRequestAnimationFrame,
            cancelAnimationFrame: fallbackCancelAnimationFrame,
            setTimeout: fallbackSetTimeout,
            clearTimeout: fallbackClearTimeout,
        };
    }

    return {
        window,
        document,
        focusElement: (element) => {
            element?.focus();
        },
        getElementById: (id) => {
            const element = document.getElementById(id);
            return element instanceof HTMLElement ? element : null;
        },
        requestAnimationFrame: window.requestAnimationFrame.bind(window),
        cancelAnimationFrame: window.cancelAnimationFrame.bind(window),
        setTimeout: window.setTimeout.bind(window),
        clearTimeout: window.clearTimeout.bind(window),
    };
};

const defaultDomEnvironment = createDomEnvironment();

export { createDomEnvironment, defaultDomEnvironment };
